import { ProfessionalBodyDTO } from '@src/adapters/dto/professionalbody/ProfessionalBodyDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {}

interface Result {
  items: ProfessionalBodyDTO[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/professional_bodies/for_selection/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindProfessionalBodiesForSelection = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};
export const useFindProfessionalBodiesForSelectionLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};
